// import Admin from './admin'
import App from './app'
// import Docs from './docs'
import Users from './users'

export const routes: any[] = [...Users, ...App]
